import * as v from "@thi.ng/vectors";
import { Atom, Molecule } from "./structure";

export const width = 20;
export const height = 5;

function coordinatesToScreenSpace(sf: number, coordinates: v.Vec2): v.Vec2 {
  return v.asVec2(
    v.mulN2(null, v.add2([], coordinates, [width / 2, height / 2]), sf),
  );
}

export function render(
  ctx: CanvasRenderingContext2D,
  sf: number,
  molecule: Molecule,
) {
  const atomRadius = 1.3;

  for (const bond of molecule.bonds) {
    const a = molecule.atoms[bond.atoms[0]];
    const b = molecule.atoms[bond.atoms[1]];
    const angleDeg = v.angleBetween2(a.currentLocation, b.currentLocation);
    const angleRad = (angleDeg / 360) * 2 * Math.PI;
    console.log(a.id, b.id, angleRad);
    const bAngleRad = angleRad - Math.PI;

    // Draw two lines between the two atoms, distanced by this amount of radians
    const distance = 0.5;
    for (const offset of [distance / 2, -distance / 2]) {
      const startRad = angleRad + offset;
      const endRad = bAngleRad - offset;
      const startPosition = v.asVec2(
        v.add2(
          null,
          v.mulN2(null, [Math.cos(startRad), Math.sin(endRad)], atomRadius),
          a.currentLocation,
        ),
      );
      const endPosition = v.asVec2(
        v.add2(
          null,
          v.mulN2(null, [Math.cos(endRad), Math.sin(endRad)], atomRadius),
          b.currentLocation,
        ),
      );
      ctx.beginPath();
      ctx.lineWidth = 0.2 * sf;
      ctx.strokeStyle = "white";
      ctx.shadowBlur = 6;
      ctx.shadowColor = "white";
      const startScreenSpace = coordinatesToScreenSpace(sf, startPosition);
      const endScreenSpace = coordinatesToScreenSpace(sf, endPosition);
      ctx.moveTo(startScreenSpace.x, startScreenSpace.y);
      ctx.lineTo(endScreenSpace.x, endScreenSpace.y);
      ctx.stroke();
    }
  }

  for (const atom of molecule.atoms) {
    const coords = coordinatesToScreenSpace(sf, atom.currentLocation);
    ctx.beginPath();
    ctx.arc(coords.x, coords.y, atomRadius * sf, 0, 2 * Math.PI);
    ctx.lineWidth = 0.2 * sf;
    ctx.strokeStyle = atom.color;
    ctx.shadowBlur = 6;
    ctx.shadowColor = atom.color;
    ctx.stroke();

    ctx.beginPath();
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillStyle = "white";
    ctx.font = `${sf * 1}px sans-serif`;
    ctx.textRendering = "optimizeLegibility";
    ctx.shadowBlur = 5;
    ctx.shadowColor = "white";
    ctx.fillText(atom.text, coords.x, coords.y);
  }
}
